<template>
  <v-card class="qa-card qa-filters" elevation="0">
    <v-card-title class="qa-filters-title">
      <v-icon class="qa-icon-accent" size="22">mdi-tune-variant</v-icon>
      <span>{{ title }}</span>
    </v-card-title>
    <!-- <v-divider /> -->
    <v-card-text class="qa-filters-body">
      <v-row align="center">
        <v-col cols="12" :lg="isAdmin ? 2 : 12">
          <v-text-field
            :value="filters.search"
            @input="updateFilter('search', $event)"
            prepend-inner-icon="mdi-magnify"
            label="بحث في السؤال، الإجابة، أو اسم المستخدم"
            hide-details
            outlined
            clearable
            class="qa-field"
            @keyup.enter="onApplyFilters"
          />
        </v-col>
        <v-col cols="12" sm="6" lg="2" v-if="isAdmin">
          <v-autocomplete
            :value="filters.author_user_id"
            @input="updateFilter('author_user_id', $event)"
            :items="allUsers"
            item-text="name"
            item-value="id"
            label="صاحب السؤال"
            hide-details
            outlined
            clearable
            class="qa-field"
          />
        </v-col>
        <v-col cols="12" sm="6" lg="2" v-if="isAdmin">
          <v-select
            :value="filters.has_comments"
            @input="updateFilter('has_comments', $event)"
            :items="triStateOptions"
            item-text="label"
            item-value="value"
            label="التعليقات"
            hide-details
            outlined
            class="qa-field"
          />
        </v-col>
        <v-col cols="12" sm="6" lg="2" v-if="isAdmin">
          <v-autocomplete
            :value="filters.comment_user_id"
            @input="updateFilter('comment_user_id', $event)"
            :items="allUsers"
            item-text="name"
            item-value="id"
            label="من علّق"
            hide-details
            outlined
            clearable
            class="qa-field"
          />
        </v-col>
        <v-col cols="12" sm="6" lg="2" v-if="isAdmin">
          <v-select
            :value="filters.has_likes"
            @input="updateFilter('has_likes', $event)"
            :items="triStateOptions"
            item-text="label"
            item-value="value"
            label="إعجابات السؤال"
            hide-details
            outlined
            class="qa-field"
          />
        </v-col>
        <v-col cols="12" sm="6" lg="2" v-if="isAdmin">
          <v-select
            :value="filters.has_comment_likes"
            @input="updateFilter('has_comment_likes', $event)"
            :items="triStateOptions"
            item-text="label"
            item-value="value"
            label="إعجابات التعليق"
            hide-details
            outlined
            class="qa-field"
          />
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider />

    <div class="qa-toolbar">
      <div class="qa-toolbar-group">
        <span class="qa-toolbar-label">{{ toolbarLabel }}</span>
        <div class="qa-segmented">
          <button
            type="button"
            class="qa-segmented-btn"
            :class="{ 'qa-segmented-btn--active': activeTab === 'all' }"
            @click="onSwitchTab('all')"
          >
            <v-icon size="18" class="qa-icon-in-btn">mdi-forum-outline</v-icon>
            جميع الأسئلة
          </button>
          <button
            type="button"
            class="qa-segmented-btn"
            :class="{ 'qa-segmented-btn--active': activeTab === 'mine' }"
            @click="onSwitchTab('mine')"
          >
            <v-icon size="18" class="qa-icon-in-btn">mdi-account-question-outline</v-icon>
            أسئلتي
          </button>
        </div>
      </div>

      <div class="qa-toolbar-group qa-toolbar-actions">
        <button type="button" class="qa-btn qa-btn-outline" @click="onResetFilters">
          <v-icon size="18" class="qa-icon-in-btn">mdi-filter-off-outline</v-icon>
          مسح الفلاتر
        </button>
        <button type="button" class="qa-btn qa-btn-primary" @click="onApplyFilters">
          <v-icon size="18" class="qa-icon-in-btn">mdi-magnify</v-icon>
          بحث وتطبيق
        </button>
      </div>
    </div>
  </v-card>
</template>
<script>
export default {
  name: "QuestionAndAnswerSearchComponent",
  props: {
    filters: {
      type: Object,
      required: true,
    },
    allUsers: {
      type: Array,
      default: () => [],
    },
    activeTab: {
      type: String,
      default: "all",
    },
    title: {
      type: String,
      default: "بحث وتصفية",
    },
    toolbarLabel: {
      type: String,
      default: "عرض المنشورات",
    },
    isAdmin: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      triStateOptions: [
        { label: "الكل", value: "all" },
        { label: "نعم", value: "yes" },
        { label: "لا", value: "no" },
      ],
    };
  },
  methods: {
    updateFilter(key, value) {
      this.$emit("update:filters", {
        ...this.filters,
        [key]: value,
      });
    },
    onApplyFilters() {
      this.$emit("apply-filters");
    },
    onResetFilters() {
      this.$emit("reset-filters");
    },
    onSwitchTab(type) {
      this.$emit("switch-tab", type);
    },
  },
};
</script>
<style scoped>
.qa-card {
  margin-bottom: 16px;
}

.qa-filters-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.05rem !important;
  font-weight: 700 !important;
  color: var(--qa-text) !important;
  padding: 14px 18px !important;
}

.qa-filters-body {
  padding: 16px 18px 10px !important;
}

.qa-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px 14px;
  background: var(--qa-segment-bg);
  border-radius: 0 0 14px 14px;
}

.qa-toolbar-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.qa-toolbar-actions {
  gap: 8px;
}

.qa-segmented {
  display: inline-flex;
  padding: 3px;
  background: var(--qa-card);
  border: 1px solid var(--qa-border);
  border-radius: 12px;
  gap: 4px;
}

.qa-segmented-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: none;
  border-radius: 9px;
  background: transparent;
  color: var(--qa-muted);
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.qa-segmented-btn:hover:not(.qa-segmented-btn--active) {
  background: var(--qa-accent-soft);
  color: var(--qa-accent);
}

.qa-segmented-btn--active {
  background: var(--qa-accent);
  color: #fff !important;
}

.qa-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 10px;
  font-size: 0.92rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: background 0.2s, color 0.2s, border-color 0.2s, opacity 0.2s;
  white-space: nowrap;
}

.qa-btn-outline {
  background: var(--qa-card);
  color: var(--qa-outline-text) !important;
  border: 1.5px solid var(--qa-accent);
}

.qa-btn-primary {
  background: var(--qa-accent);
  color: var(--qa-btn-text) !important;
}

.qa-field {
  width: 100%;
}

.qa-filters >>> .v-input__slot,
.qa-filters >>> .v-autocomplete__content,
.qa-filters >>> .v-select__selections {
  background: var(--qa-card) !important;
  min-height: 46px !important;
}

.qa-filters >>> fieldset {
  border-color: var(--qa-border) !important;
  border-width: 1.3px !important;
}

.qa-filters >>> .v-label,
.qa-filters >>> input,
.qa-filters >>> textarea {
  color: var(--qa-text) !important;
  font-size: 0.93rem !important;
}

.qa-filters >>> .v-input__prepend-inner .v-icon {
  color: var(--qa-icon) !important;
}

.qa-filters >>> .v-select__slot label,
.qa-filters >>> .v-select__selection {
  color: var(--qa-text) !important;
}

.dark .qa-card {
  background: #1f2937 !important;
  border-color: #334155 !important;
}

.dark .qa-filters-body,
.dark .qa-toolbar {
  background: #111827 !important;
}

.dark .qa-segmented {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(148, 163, 184, 0.65);
}

.dark .qa-segmented-btn {
  color: #94a3b8;
}

.dark .qa-segmented-btn:hover:not(.qa-segmented-btn--active) {
  background: rgba(192, 132, 252, 0.18);
  color: #c084fc;
}

.dark .qa-segmented-btn--active {
  background: #8b5cf6;
  color: #fff !important;
}

.dark .qa-btn-outline {
  background: rgba(255, 255, 255, 0.05);
  color: var(--qa-text) !important;
  border-color: rgba(148, 163, 184, 0.8) !important;
}

.dark .qa-btn-primary {
  background: #c084fc;
  color: var(--qa-btn-text) !important;
}

.dark .qa-filters-title,
.dark .qa-title,
.dark .qa-post-question,
.dark .qa-comment-text,
.dark .qa-comment-author,
.dark .qa-post-name,
.dark .qa-filter-text {
  color: var(--qa-text) !important;
}

.dark .qa-filters >>> .v-input__slot,
.dark .qa-filters >>> .v-autocomplete__content,
.dark .qa-filters >>> .v-select__selections {
  background: #1f2937 !important;
}

.dark .qa-filters >>> fieldset {
  border-color: rgba(148, 163, 184, 0.8) !important;
}
</style>